import { mapGetters } from 'vuex';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import mvtCardAgent from '@/common/components/mvtcardagent/mvt-cardagent.vue';

export default {
    name: 'brokerageAgent',
    inject: ['$eventBus'],
    components: {
        mvtMapStatic,
        mvtCardAgent
    },
    computed:{
        ...mapGetters('glb', ['glb']),
        ...mapGetters('agents', ['brokerage'])
    }
};